import type { FC } from "react";
import { SelectWithColors } from "../../components/entityCard/SelectWithColors";
import { CostStatusColors } from "../../data/BaseEntity";
import type { CostStatus } from "../costApi";
import { statusToName } from "../costsUtils";

interface Props {
  status: CostStatus;
  onChange: (value: CostStatus) => void;
}

const costSelectValues = Object.entries(statusToName).map(([status, name]) => ({
  id: status as CostStatus,
  label: name,
}));

const CostStatusSelect: FC<Props> = ({ status, onChange }) => (
  <SelectWithColors<CostStatus>
    label="Status kosztu"
    values={costSelectValues}
    colors={CostStatusColors}
    value={status}
    onChange={onChange}
  />
);

export default CostStatusSelect;
